import { HorizontalBar, mixins } from 'vue-chartjs';
import merge from 'lodash.merge';
const { reactiveProp } = mixins;

const defaultOptions = {
  animation: {
    duration: 2000,
    easing: `easeOutQuart`,
  },
  legend: {
    display: false
  },
  maintainAspectRatio: false,
  scales: {
    yAxes: [{
      id: `left-y-axis`,
      position: `left`,
      gridLines: {
        display: false,
        drawBorder: false,
        drawOnChartArea: false,
        lineWidth: 1,
        borderDash: [8, 4]
      },
      ticks: {
        beginAtZero: false
      }
    }],
    xAxes: [{
      gridLines: {
        display: false,
        drawBorder: false,
        drawOnChartArea: false
      },
      ticks: {
        beginAtZero: true,
        maxTicksLimit: 10,
        maxRotation: 0,
      }
    }]
  },
  tooltips: {
    displayColors: false,
    mode: `nearest`,
    intersect: false,
    borderColor: `rgba(177, 184, 199, 1)`,
    caretPadding: 10,
    caretSize: 0,
    cornerRadius: 2,
    borderWidth: 1,
    backgroundColor: `rgba(255, 255, 255, 1)`,
    titleFontColor: `rgba(0,0,0,1)`,
    titleFontStyle: `normal`,
    bodyFontColor: `rgba(177, 184, 199, 1)`,
    footerFontColor: `rgba(0,0,0,1)`
  }
};

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  methods: {
    render() {
      this.renderChart(this.chartData, merge(this.options, defaultOptions));
    }
  },
  watch: {
    options () {
      this.render();
    },
    chartData() {
      this.render();
    }
  },
  mounted() {
    this.render();
  }
};
